// extracted by mini-css-extract-plugin
export default {"wrap":"PlatformItems_wrap__-+J5g","link":"PlatformItems_link__vk3cG"};